<template>
  <div v-loading.fullscreen.lock="true"></div>
</template>

<script>
import Vue from "vue";
import { AUTH_REQUEST } from "../store/actions/auth";

export default {
  name: "Login",
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("AUTH_REQUEST");
  }
};
</script>
